import React, { FC } from 'react';
import { Assignee, TurbineInfo, changeAssignee } from '../Landing.slice';
import { RootState } from '../../../../rootReducer';
import { AppDispatch } from '../../../../store';
import { connect } from 'react-redux';
import { Modal, Select } from 'antd';
import { Permissions } from '../../../../shared/models/permissions.enum';
import { UseHaveAnyPermissions } from '../../../../Auth/UseHaveAnyPermissions';
import useAuth from '../../../../Auth/UseAuth';

type Props = {
  turbine: TurbineInfo;
  availableAssignees: Assignee[];
  onChangeAsignee: (id: string | undefined, fullName: string | undefined, turbineId: string, isRemoving: boolean) => void;
};

const { Option } = Select;

const ASSIGN_TO_ME = 'Assigned to me';

export const AssigneeColumn: FC<Props> = ({ turbine, availableAssignees, onChangeAsignee }) => {
  const canReassign = UseHaveAnyPermissions([Permissions.AnnotationManager_AssignTurbine, Permissions.AnnotationManager_UnassignTurbine]);
  const { userId } = useAuth();

  const onChange = (id: string) => {
    const fullName = assignees.find(x => x.id === id)?.fullName;
    const newAssigned = fullName === ASSIGN_TO_ME ? 'turbine' : fullName;

    Modal.confirm({
      title: 'Confirm',
      content: !id ? `Are you sure you want to remove assingee ${turbine.userName} from turbine?` : `Are you sure you want to assing ${newAssigned}?`,
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => {
        onChangeAsignee(id, fullName, turbine.turbineId, !id);
      },
      onCancel: () => {
        return;
      }
    });
  };

  if (availableAssignees.length === 0 || !canReassign) {
    return <span>{turbine?.userName}</span>;
  }

  let assignees = [...availableAssignees];
  if (turbine.userId && !availableAssignees.find(x => x.id === turbine.userId)) {
    assignees.push({
      id: turbine.userId,
      fullName: turbine.userName
    });
  }

  if (userId && assignees.length) {
    let currentUser = assignees.find(x => x.id === userId);
    if (currentUser) {
      assignees = [
        {
          ...currentUser,
          fullName: ASSIGN_TO_ME
        },
        ...assignees.filter(x => x.id !== userId)
      ];
    }
  }

  return (
    <Select
      showSearch
      allowClear={!!turbine.userId}
      style={{ width: 200 }}
      placeholder='Select assignee'
      optionFilterProp='children'
      onChange={onChange}
      value={turbine.userId}
      filterOption={true}
    >
      {assignees.map(item => (
        <Option value={item.id} key={item.id}>
          {item.fullName}
        </Option>
      ))}
    </Select>
  );
};

const mapStateToProps = (state: RootState) => ({
  availableAssignees: state.landing.assignees
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  onChangeAsignee: (id: string | undefined, fullName: string | undefined, turbineId: string, isRemoving: boolean) =>
    dispatch(changeAssignee(id, fullName, turbineId, isRemoving))
});

export default connect(mapStateToProps, mapDispatchToProps)(AssigneeColumn);
